@if (isForbidden() === false && notFound() === false) {
  <immo-toast-stack />
  <div
    [attr.data-layout-bp]="breakpoint"
    class="flex h-dvh flex-col layout-bp:flex-row overflow-x-hidden overflow-y-auto"
  >
    <backoffice-base-layout-header class="sticky top-0 z-50 shrink-0 layout-bp:hidden!" />
    <backoffice-base-layout-sidebar class="sticky top-0 shrink-0 hidden! layout-bp:block!" />

    <main class="grow flex flex-col">
      <div class="flex-1" [class.p-5]="!fullBleed()">
        <router-outlet />
      </div>
    </main>
  </div>
}

@if (isNavigating() || isLoading()) {
  <div class="fixed right-0 top-0" animate.enter="appear" animate.leave="disappear">
    <div class="m-5 p-2 bg-surface-container-highest shadow-5 rounded-md">
      <mat-spinner diameter="20" />
    </div>
  </div>
}
